import { createElement, memo, useContext } from '@max/max';
import BottomSlideModal from './components/slide-modal';
import './index.scss';
const MyComponent = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    // 调用引擎注入的自定义API
    const moduleId = ctx._moduleId;
    return <>
      <BottomSlideModal {...props}/>
    </>;
};
export default memo(MyComponent);
